var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FadeOutUp = exports.FadeOutRight = exports.FadeOutLeft = exports.FadeOutDown = exports.FadeOut = exports.FadeInUp = exports.FadeInRight = exports.FadeInLeft = exports.FadeInDown = exports.FadeIn = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _animationBuilder = require("../animationBuilder");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return (0, _possibleConstructorReturn2.default)(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var _worklet_15881371197445_init_data = {
    code: "function anonymous(){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{opacity:delayFunction(delay,animation(1,config))},initialValues:{opacity:0,...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Fade.ts",
    sourceMap: '{"version":3,"names":["anonymous","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","opacity"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Fade.ts"],"mappings":"AAwBW,SAAAA,SAAMA,CAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEX,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CACpD,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAE,CAAC,CACV,GAAGJ,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var FadeIn = exports.FadeIn = function(_ComplexAnimationBuil) {
    (0, _inherits2.default)(FadeIn, _ComplexAnimationBuil);
    var _super = _createSuper(FadeIn);
    function FadeIn() {
        var _this;
        (0, _classCallCheck2.default)(this, FadeIn);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.build = function() {
            var delayFunction = _this.getDelayFunction();
            var _this$getAnimationAnd = _this.getAnimationAndConfig(), _this$getAnimationAnd2 = (0, _slicedToArray2.default)(_this$getAnimationAnd, 2), animation = _this$getAnimationAnd2[0], config = _this$getAnimationAnd2[1];
            var callback = _this.callbackV;
            var initialValues = _this.initialValues;
            var delay = _this.getDelay();
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous() {
                    return {
                        animations: {
                            opacity: delayFunction(delay, animation(1, config))
                        },
                        initialValues: Object.assign({
                            opacity: 0
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_15881371197445_init_data;
                anonymous.__workletHash = 15881371197445;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this;
    }
    (0, _createClass2.default)(FadeIn, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new FadeIn();
            }
        }
    ]);
    return FadeIn;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_9172155159308_init_data = {
    code: "function anonymous(){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{opacity:delayFunction(delay,animation(1,config)),transform:[{translateX:delayFunction(delay,animation(0,config))}]},initialValues:{opacity:0,transform:[{translateX:25}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Fade.ts",
    sourceMap: '{"version":3,"names":["anonymous","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","opacity","transform","translateX"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Fade.ts"],"mappings":"AAyDW,SAAAA,SAAMA,CAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEX,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAC,CACnDM,SAAS,CAAE,CACT,CAAEC,UAAU,CAAEV,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAE,CAAC,CAE9D,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAE,CAAC,CACVC,SAAS,CAAE,CAAC,CAAEC,UAAU,CAAE,EAAG,CAAC,CAAC,CAC/B,GAAGN,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var FadeInRight = exports.FadeInRight = function(_ComplexAnimationBuil2) {
    (0, _inherits2.default)(FadeInRight, _ComplexAnimationBuil2);
    var _super2 = _createSuper(FadeInRight);
    function FadeInRight() {
        var _this2;
        (0, _classCallCheck2.default)(this, FadeInRight);
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++){
            args[_key2] = arguments[_key2];
        }
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        _this2.build = function() {
            var delayFunction = _this2.getDelayFunction();
            var _this2$getAnimationAn = _this2.getAnimationAndConfig(), _this2$getAnimationAn2 = (0, _slicedToArray2.default)(_this2$getAnimationAn, 2), animation = _this2$getAnimationAn2[0], config = _this2$getAnimationAn2[1];
            var callback = _this2.callbackV;
            var initialValues = _this2.initialValues;
            var delay = _this2.getDelay();
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous() {
                    return {
                        animations: {
                            opacity: delayFunction(delay, animation(1, config)),
                            transform: [
                                {
                                    translateX: delayFunction(delay, animation(0, config))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            opacity: 0,
                            transform: [
                                {
                                    translateX: 25
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_9172155159308_init_data;
                anonymous.__workletHash = 9172155159308;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this2;
    }
    (0, _createClass2.default)(FadeInRight, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new FadeInRight();
            }
        }
    ]);
    return FadeInRight;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_9404178568353_init_data = {
    code: "function anonymous(){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{opacity:delayFunction(delay,animation(1,config)),transform:[{translateX:delayFunction(delay,animation(0,config))}]},initialValues:{opacity:0,transform:[{translateX:-25}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Fade.ts",
    sourceMap: '{"version":3,"names":["anonymous","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","opacity","transform","translateX"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Fade.ts"],"mappings":"AA8FW,SAAAA,SAAMA,CAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEX,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAC,CACnDM,SAAS,CAAE,CACT,CAAEC,UAAU,CAAEV,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAE,CAAC,CAE9D,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAE,CAAC,CACVC,SAAS,CAAE,CAAC,CAAEC,UAAU,CAAE,CAAC,EAAG,CAAC,CAAC,CAChC,GAAGN,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var FadeInLeft = exports.FadeInLeft = function(_ComplexAnimationBuil3) {
    (0, _inherits2.default)(FadeInLeft, _ComplexAnimationBuil3);
    var _super3 = _createSuper(FadeInLeft);
    function FadeInLeft() {
        var _this3;
        (0, _classCallCheck2.default)(this, FadeInLeft);
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++){
            args[_key3] = arguments[_key3];
        }
        _this3 = _super3.call.apply(_super3, [
            this
        ].concat(args));
        _this3.build = function() {
            var delayFunction = _this3.getDelayFunction();
            var _this3$getAnimationAn = _this3.getAnimationAndConfig(), _this3$getAnimationAn2 = (0, _slicedToArray2.default)(_this3$getAnimationAn, 2), animation = _this3$getAnimationAn2[0], config = _this3$getAnimationAn2[1];
            var callback = _this3.callbackV;
            var initialValues = _this3.initialValues;
            var delay = _this3.getDelay();
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous() {
                    return {
                        animations: {
                            opacity: delayFunction(delay, animation(1, config)),
                            transform: [
                                {
                                    translateX: delayFunction(delay, animation(0, config))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            opacity: 0,
                            transform: [
                                {
                                    translateX: -25
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_9404178568353_init_data;
                anonymous.__workletHash = 9404178568353;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this3;
    }
    (0, _createClass2.default)(FadeInLeft, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new FadeInLeft();
            }
        }
    ]);
    return FadeInLeft;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_15308047400737_init_data = {
    code: "function anonymous(){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{opacity:delayFunction(delay,animation(1,config)),transform:[{translateY:delayFunction(delay,animation(0,config))}]},initialValues:{opacity:0,transform:[{translateY:-25}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Fade.ts",
    sourceMap: '{"version":3,"names":["anonymous","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","opacity","transform","translateY"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Fade.ts"],"mappings":"AAmIW,SAAAA,SAAMA,CAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEX,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAC,CACnDM,SAAS,CAAE,CACT,CAAEC,UAAU,CAAEV,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAE,CAAC,CAE9D,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAE,CAAC,CACVC,SAAS,CAAE,CAAC,CAAEC,UAAU,CAAE,CAAC,EAAG,CAAC,CAAC,CAChC,GAAGN,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var FadeInUp = exports.FadeInUp = function(_ComplexAnimationBuil4) {
    (0, _inherits2.default)(FadeInUp, _ComplexAnimationBuil4);
    var _super4 = _createSuper(FadeInUp);
    function FadeInUp() {
        var _this4;
        (0, _classCallCheck2.default)(this, FadeInUp);
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++){
            args[_key4] = arguments[_key4];
        }
        _this4 = _super4.call.apply(_super4, [
            this
        ].concat(args));
        _this4.build = function() {
            var delayFunction = _this4.getDelayFunction();
            var _this4$getAnimationAn = _this4.getAnimationAndConfig(), _this4$getAnimationAn2 = (0, _slicedToArray2.default)(_this4$getAnimationAn, 2), animation = _this4$getAnimationAn2[0], config = _this4$getAnimationAn2[1];
            var callback = _this4.callbackV;
            var initialValues = _this4.initialValues;
            var delay = _this4.getDelay();
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous() {
                    return {
                        animations: {
                            opacity: delayFunction(delay, animation(1, config)),
                            transform: [
                                {
                                    translateY: delayFunction(delay, animation(0, config))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            opacity: 0,
                            transform: [
                                {
                                    translateY: -25
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_15308047400737_init_data;
                anonymous.__workletHash = 15308047400737;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this4;
    }
    (0, _createClass2.default)(FadeInUp, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new FadeInUp();
            }
        }
    ]);
    return FadeInUp;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_2097831289868_init_data = {
    code: "function anonymous(){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{opacity:delayFunction(delay,animation(1,config)),transform:[{translateY:delayFunction(delay,animation(0,config))}]},initialValues:{opacity:0,transform:[{translateY:25}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Fade.ts",
    sourceMap: '{"version":3,"names":["anonymous","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","opacity","transform","translateY"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Fade.ts"],"mappings":"AAwKW,SAAAA,SAAMA,CAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEX,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAC,CACnDM,SAAS,CAAE,CACT,CAAEC,UAAU,CAAEV,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAE,CAAC,CAE9D,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAE,CAAC,CACVC,SAAS,CAAE,CAAC,CAAEC,UAAU,CAAE,EAAG,CAAC,CAAC,CAC/B,GAAGN,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var FadeInDown = exports.FadeInDown = function(_ComplexAnimationBuil5) {
    (0, _inherits2.default)(FadeInDown, _ComplexAnimationBuil5);
    var _super5 = _createSuper(FadeInDown);
    function FadeInDown() {
        var _this5;
        (0, _classCallCheck2.default)(this, FadeInDown);
        for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++){
            args[_key5] = arguments[_key5];
        }
        _this5 = _super5.call.apply(_super5, [
            this
        ].concat(args));
        _this5.build = function() {
            var delayFunction = _this5.getDelayFunction();
            var _this5$getAnimationAn = _this5.getAnimationAndConfig(), _this5$getAnimationAn2 = (0, _slicedToArray2.default)(_this5$getAnimationAn, 2), animation = _this5$getAnimationAn2[0], config = _this5$getAnimationAn2[1];
            var callback = _this5.callbackV;
            var initialValues = _this5.initialValues;
            var delay = _this5.getDelay();
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous() {
                    return {
                        animations: {
                            opacity: delayFunction(delay, animation(1, config)),
                            transform: [
                                {
                                    translateY: delayFunction(delay, animation(0, config))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            opacity: 0,
                            transform: [
                                {
                                    translateY: 25
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_2097831289868_init_data;
                anonymous.__workletHash = 2097831289868;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this5;
    }
    (0, _createClass2.default)(FadeInDown, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new FadeInDown();
            }
        }
    ]);
    return FadeInDown;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_9000373842853_init_data = {
    code: "function anonymous(){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{opacity:delayFunction(delay,animation(0,config))},initialValues:{opacity:1,...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Fade.ts",
    sourceMap: '{"version":3,"names":["anonymous","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","opacity"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Fade.ts"],"mappings":"AA6MW,SAAAA,SAAMA,CAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEX,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CACpD,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAE,CAAC,CACV,GAAGJ,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var FadeOut = exports.FadeOut = function(_ComplexAnimationBuil6) {
    (0, _inherits2.default)(FadeOut, _ComplexAnimationBuil6);
    var _super6 = _createSuper(FadeOut);
    function FadeOut() {
        var _this6;
        (0, _classCallCheck2.default)(this, FadeOut);
        for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++){
            args[_key6] = arguments[_key6];
        }
        _this6 = _super6.call.apply(_super6, [
            this
        ].concat(args));
        _this6.build = function() {
            var delayFunction = _this6.getDelayFunction();
            var _this6$getAnimationAn = _this6.getAnimationAndConfig(), _this6$getAnimationAn2 = (0, _slicedToArray2.default)(_this6$getAnimationAn, 2), animation = _this6$getAnimationAn2[0], config = _this6$getAnimationAn2[1];
            var callback = _this6.callbackV;
            var initialValues = _this6.initialValues;
            var delay = _this6.getDelay();
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous() {
                    return {
                        animations: {
                            opacity: delayFunction(delay, animation(0, config))
                        },
                        initialValues: Object.assign({
                            opacity: 1
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_9000373842853_init_data;
                anonymous.__workletHash = 9000373842853;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this6;
    }
    (0, _createClass2.default)(FadeOut, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new FadeOut();
            }
        }
    ]);
    return FadeOut;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_13181671880172_init_data = {
    code: "function anonymous(){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{opacity:delayFunction(delay,animation(0,config)),transform:[{translateX:delayFunction(delay,animation(25,config))}]},initialValues:{opacity:1,transform:[{translateX:0}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Fade.ts",
    sourceMap: '{"version":3,"names":["anonymous","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","opacity","transform","translateX"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Fade.ts"],"mappings":"AA8OW,SAAAA,SAAMA,CAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEX,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAC,CACnDM,SAAS,CAAE,CACT,CAAEC,UAAU,CAAEV,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,EAAE,CAAEC,MAAM,CAAC,CAAE,CAAC,CAE/D,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAE,CAAC,CACVC,SAAS,CAAE,CAAC,CAAEC,UAAU,CAAE,CAAE,CAAC,CAAC,CAC9B,GAAGN,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var FadeOutRight = exports.FadeOutRight = function(_ComplexAnimationBuil7) {
    (0, _inherits2.default)(FadeOutRight, _ComplexAnimationBuil7);
    var _super7 = _createSuper(FadeOutRight);
    function FadeOutRight() {
        var _this7;
        (0, _classCallCheck2.default)(this, FadeOutRight);
        for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++){
            args[_key7] = arguments[_key7];
        }
        _this7 = _super7.call.apply(_super7, [
            this
        ].concat(args));
        _this7.build = function() {
            var delayFunction = _this7.getDelayFunction();
            var _this7$getAnimationAn = _this7.getAnimationAndConfig(), _this7$getAnimationAn2 = (0, _slicedToArray2.default)(_this7$getAnimationAn, 2), animation = _this7$getAnimationAn2[0], config = _this7$getAnimationAn2[1];
            var callback = _this7.callbackV;
            var initialValues = _this7.initialValues;
            var delay = _this7.getDelay();
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous() {
                    return {
                        animations: {
                            opacity: delayFunction(delay, animation(0, config)),
                            transform: [
                                {
                                    translateX: delayFunction(delay, animation(25, config))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            opacity: 1,
                            transform: [
                                {
                                    translateX: 0
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_13181671880172_init_data;
                anonymous.__workletHash = 13181671880172;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this7;
    }
    (0, _createClass2.default)(FadeOutRight, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new FadeOutRight();
            }
        }
    ]);
    return FadeOutRight;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_13821183888769_init_data = {
    code: "function anonymous(){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{opacity:delayFunction(delay,animation(0,config)),transform:[{translateX:delayFunction(delay,animation(-25,config))}]},initialValues:{opacity:1,transform:[{translateX:0}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Fade.ts",
    sourceMap: '{"version":3,"names":["anonymous","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","opacity","transform","translateX"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Fade.ts"],"mappings":"AAmRW,SAAAA,SAAMA,CAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEX,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAC,CACnDM,SAAS,CAAE,CACT,CAAEC,UAAU,CAAEV,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,EAAE,CAAEC,MAAM,CAAC,CAAE,CAAC,CAEhE,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAE,CAAC,CACVC,SAAS,CAAE,CAAC,CAAEC,UAAU,CAAE,CAAE,CAAC,CAAC,CAC9B,GAAGN,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var FadeOutLeft = exports.FadeOutLeft = function(_ComplexAnimationBuil8) {
    (0, _inherits2.default)(FadeOutLeft, _ComplexAnimationBuil8);
    var _super8 = _createSuper(FadeOutLeft);
    function FadeOutLeft() {
        var _this8;
        (0, _classCallCheck2.default)(this, FadeOutLeft);
        for(var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++){
            args[_key8] = arguments[_key8];
        }
        _this8 = _super8.call.apply(_super8, [
            this
        ].concat(args));
        _this8.build = function() {
            var delayFunction = _this8.getDelayFunction();
            var _this8$getAnimationAn = _this8.getAnimationAndConfig(), _this8$getAnimationAn2 = (0, _slicedToArray2.default)(_this8$getAnimationAn, 2), animation = _this8$getAnimationAn2[0], config = _this8$getAnimationAn2[1];
            var callback = _this8.callbackV;
            var initialValues = _this8.initialValues;
            var delay = _this8.getDelay();
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous() {
                    return {
                        animations: {
                            opacity: delayFunction(delay, animation(0, config)),
                            transform: [
                                {
                                    translateX: delayFunction(delay, animation(-25, config))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            opacity: 1,
                            transform: [
                                {
                                    translateX: 0
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_13821183888769_init_data;
                anonymous.__workletHash = 13821183888769;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this8;
    }
    (0, _createClass2.default)(FadeOutLeft, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new FadeOutLeft();
            }
        }
    ]);
    return FadeOutLeft;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_890778954817_init_data = {
    code: "function anonymous(){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{opacity:delayFunction(delay,animation(0,config)),transform:[{translateY:delayFunction(delay,animation(-25,config))}]},initialValues:{opacity:1,transform:[{translateY:0}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Fade.ts",
    sourceMap: '{"version":3,"names":["anonymous","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","opacity","transform","translateY"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Fade.ts"],"mappings":"AAwTW,SAAAA,SAAMA,CAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEX,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAC,CACnDM,SAAS,CAAE,CACT,CAAEC,UAAU,CAAEV,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,EAAE,CAAEC,MAAM,CAAC,CAAE,CAAC,CAEhE,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAE,CAAC,CACVC,SAAS,CAAE,CAAC,CAAEC,UAAU,CAAE,CAAE,CAAC,CAAC,CAC9B,GAAGN,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var FadeOutUp = exports.FadeOutUp = function(_ComplexAnimationBuil9) {
    (0, _inherits2.default)(FadeOutUp, _ComplexAnimationBuil9);
    var _super9 = _createSuper(FadeOutUp);
    function FadeOutUp() {
        var _this9;
        (0, _classCallCheck2.default)(this, FadeOutUp);
        for(var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++){
            args[_key9] = arguments[_key9];
        }
        _this9 = _super9.call.apply(_super9, [
            this
        ].concat(args));
        _this9.build = function() {
            var delayFunction = _this9.getDelayFunction();
            var _this9$getAnimationAn = _this9.getAnimationAndConfig(), _this9$getAnimationAn2 = (0, _slicedToArray2.default)(_this9$getAnimationAn, 2), animation = _this9$getAnimationAn2[0], config = _this9$getAnimationAn2[1];
            var callback = _this9.callbackV;
            var initialValues = _this9.initialValues;
            var delay = _this9.getDelay();
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous() {
                    return {
                        animations: {
                            opacity: delayFunction(delay, animation(0, config)),
                            transform: [
                                {
                                    translateY: delayFunction(delay, animation(-25, config))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            opacity: 1,
                            transform: [
                                {
                                    translateY: 0
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_890778954817_init_data;
                anonymous.__workletHash = 890778954817;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this9;
    }
    (0, _createClass2.default)(FadeOutUp, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new FadeOutUp();
            }
        }
    ]);
    return FadeOutUp;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_17514982472204_init_data = {
    code: "function anonymous(){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{opacity:delayFunction(delay,animation(0,config)),transform:[{translateY:delayFunction(delay,animation(25,config))}]},initialValues:{opacity:1,transform:[{translateY:0}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Fade.ts",
    sourceMap: '{"version":3,"names":["anonymous","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","opacity","transform","translateY"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Fade.ts"],"mappings":"AA6VW,SAAAA,SAAMA,CAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEX,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAC,CACnDM,SAAS,CAAE,CACT,CAAEC,UAAU,CAAEV,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,EAAE,CAAEC,MAAM,CAAC,CAAE,CAAC,CAE/D,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAE,CAAC,CACVC,SAAS,CAAE,CAAC,CAAEC,UAAU,CAAE,CAAE,CAAC,CAAC,CAC9B,GAAGN,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var FadeOutDown = exports.FadeOutDown = function(_ComplexAnimationBuil10) {
    (0, _inherits2.default)(FadeOutDown, _ComplexAnimationBuil10);
    var _super10 = _createSuper(FadeOutDown);
    function FadeOutDown() {
        var _this10;
        (0, _classCallCheck2.default)(this, FadeOutDown);
        for(var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++){
            args[_key10] = arguments[_key10];
        }
        _this10 = _super10.call.apply(_super10, [
            this
        ].concat(args));
        _this10.build = function() {
            var delayFunction = _this10.getDelayFunction();
            var _this10$getAnimationA = _this10.getAnimationAndConfig(), _this10$getAnimationA2 = (0, _slicedToArray2.default)(_this10$getAnimationA, 2), animation = _this10$getAnimationA2[0], config = _this10$getAnimationA2[1];
            var callback = _this10.callbackV;
            var initialValues = _this10.initialValues;
            var delay = _this10.getDelay();
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous() {
                    return {
                        animations: {
                            opacity: delayFunction(delay, animation(0, config)),
                            transform: [
                                {
                                    translateY: delayFunction(delay, animation(25, config))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            opacity: 1,
                            transform: [
                                {
                                    translateY: 0
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_17514982472204_init_data;
                anonymous.__workletHash = 17514982472204;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this10;
    }
    (0, _createClass2.default)(FadeOutDown, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new FadeOutDown();
            }
        }
    ]);
    return FadeOutDown;
}(_animationBuilder.ComplexAnimationBuilder);
